import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router, Event, NavigationStart, NavigationEnd, NavigationError, NavigationCancel } from '@angular/router';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {

  constructor(private router: Router, private title: Title) {
    this.title.setTitle(environment.clientName);

    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationStart) {
        window.scroll(0, 0);
      }
      if (event instanceof NavigationEnd) {

      }
      if (event instanceof NavigationError) {

      }
      if (event instanceof NavigationCancel) {

      }
    });
  }
}
